import { User, Star, Sparkles, History, Backpack, Dices, BriefcaseBusiness, ScrollText, FileText, type LucideIcon } from "lucide-react";

export type FlowStepKey =
  | "investigator"
  | "archetype"
  | "talents"
  | "backstory"
  | "equipment"
  | "characteristics"
  | "occupation"
  | "skills"
  | "dossier";

export interface FlowStep {
  key: FlowStepKey;
  icon: LucideIcon;
  /** Route to navigate to. "__era__" means resolve to the era's index route. */
  route: string;
}

export const getFlowSteps = (pulpMode: boolean): FlowStep[] => [
  { key: "investigator", route: "__era__", icon: User },
  ...(pulpMode
    ? ([
        { key: "archetype", route: "/archetype", icon: Star },
        { key: "talents", route: "/talents", icon: Sparkles },
      ] as FlowStep[])
    : []),
  { key: "backstory", route: "/backstory", icon: History },
  { key: "equipment", route: "/equipment", icon: Backpack },
  { key: "characteristics", route: "/characteristics", icon: Dices },
  { key: "occupation", route: "/occupation-skills", icon: BriefcaseBusiness },
  { key: "skills", route: "/personal-skills", icon: ScrollText },
  { key: "dossier", route: "/dossier", icon: FileText },
];

export const getFlowStepNumber = (key: FlowStepKey, pulpMode: boolean): number =>
  getFlowSteps(pulpMode).findIndex((s) => s.key === key) + 1;

export const getFlowTotal = (pulpMode: boolean): number => (pulpMode ? 9 : 7);